import { render, staticRenderFns } from "./Bdi2.vue?vue&type=template&id=a0b9def8&scoped=true&lang=pug&"
import script from "./Bdi2.vue?vue&type=script&lang=ts&"
export * from "./Bdi2.vue?vue&type=script&lang=ts&"
import style0 from "./Bdi2.vue?vue&type=style&index=0&id=a0b9def8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0b9def8",
  null
  
)

export default component.exports